module.exports = __webpack_public_path__ + "img/1024.62efc4e5.svg";